import * as React from "react"

type Opts = {
  collapseThreshold?: number // px scrolled
  hasCountdownTimer: boolean
  promosCount: number
  shortenThreshold?: number // px scrolled
  showPromoBanner: boolean
}

export default function useHeaderDynamics({
  collapseThreshold = 50,
  hasCountdownTimer,
  promosCount,
  shortenThreshold = 50,
  showPromoBanner,
}: Opts) {
  const [shortenDesktopHeader, setShorten] = React.useState(false)
  const [collapsePromoBanner, setCollapse] = React.useState(false)
  const rafRef = React.useRef<null | number>(null)

  React.useEffect(() => {
    const onScroll = () => {
      if (rafRef.current != null) {
        return
      }
      rafRef.current = requestAnimationFrame(() => {
        rafRef.current = null
        const y = window.scrollY || document.documentElement.scrollTop || 0
        setShorten(y > shortenThreshold)
        if (showPromoBanner && promosCount > 0) {
          setCollapse(y > collapseThreshold)
        } else {
          setCollapse(false)
        }
      })
    }

    onScroll() // initialize state
    window.addEventListener("scroll", onScroll, { passive: true })
    return () => {
      window.removeEventListener("scroll", onScroll)
      if (rafRef.current) {
        cancelAnimationFrame(rafRef.current)
      }
    }
  }, [showPromoBanner, promosCount, shortenThreshold, collapseThreshold])

  // derived values to keep math centralized
  const megaMenuOffset = React.useMemo(() => {
    return hasCountdownTimer && shortenDesktopHeader
      ? 64 + 56
      : shortenDesktopHeader
        ? 64
        : hasCountdownTimer
          ? 56 + 36 + 88
          : 36 + 88
  }, [hasCountdownTimer, shortenDesktopHeader])

  const cartToastYPosition = shortenDesktopHeader
    ? 64
    : showPromoBanner
      ? 120
      : 88

  return {
    cartToastYPosition,
    collapsePromoBanner,
    megaMenuOffset,
    shortenDesktopHeader,
  }
}
